import styled from 'styled-components';

export const TagContainer = styled.div`
  float: left;
  cursor: pointer;
  height: fit-content;
`;
